import { c as _c } from "react/compiler-runtime";
import { DialogTitle } from '@headlessui/react';
import { X } from '@phosphor-icons/react';
import type { PropsWithChildren } from 'react';
import { uiTestId } from '../../test-ids';
import { IconButton } from '../button/icon-button';
export type HeaderProps = {
  hideCloseIcon?: boolean;
  onClose: VoidFunction;
};
export const Header = t0 => {
  const $ = _c(8);
  const {
    children,
    hideCloseIcon,
    onClose
  } = t0;
  if (!children && hideCloseIcon) {
    return null;
  }
  let t1;
  if ($[0] !== children) {
    t1 = <DialogTitle as="h3" className="font-heading4 only:mx-auto sm:only:mx-0">{children}</DialogTitle>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== hideCloseIcon || $[3] !== onClose) {
    t2 = !hideCloseIcon && <CloseIcon onClick={onClose} />;
    $[2] = hideCloseIcon;
    $[3] = onClose;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div className="flex items-center justify-between px-6 pt-6 pb-2 sm:px-8">{t1}{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
const Icon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <X size={24} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export const CloseIcon = t0 => {
  const $ = _c(3);
  const {
    onClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = uiTestId("Modal.Header.close");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onClick) {
    t2 = <IconButton weight="ghost" Icon={Icon} onClick={onClick} data-testid={t1} aria-label={"Modal schlie\xDFen"} />;
    $[1] = onClick;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};